import React from "react";
import Consult from "./components/Consult";

function App() {
  return (
    <div>
      <Consult />
    </div>
  );
}

export default App;
